import React, { Component } from 'react';
import './testList.css';
import Button from '../button';
import TestListItem from '../testListItem';
import apiService from '../../services/apiService';
import Spinner from '../spinner';
import ErrorBoundry from '../error-boundry';
import ErrorIndicator from '../error-indicator';
import { Link } from 'react-router-dom';

class TestList extends Component {
  apiService = new apiService();
  state = {
    list: [],
    loading: true,
    error: false
  };

  componentDidMount() {
    this.updateList();
  }

  updateList = () => {
    this.apiService
      .getQuizList()
      .then(({ list }) => {
        this.setState({
          list,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: true
        });
      });
  };

  render() {
    return (
      <div className="admin-container__inner">
        <Link className="btn test-list__btn" to="admin/create">
          Новый тест{' '}
        </Link>
        <div className="test-list">
          {this.state.loading ? (
            <Spinner />
          ) : (
            <TestListItem list={this.state.list} />
          )}
          {this.state.error ? <ErrorIndicator /> : null}
        </div>
      </div>
    );
  }
}

export default TestList;
